import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticlePhishing() {
  return (
    <BlogArticleLayout
      tag="Cybersécurité"
      title="Phishing en entreprise : reconnaître et prévenir les attaques"
      date="15 octobre 2026"
      ctaTitle="Évaluez la vigilance de votre entreprise face au phishing"
      ctaText="Le diagnostic vérifie si vos équipes et vos procédures sont prêtes à faire face à une tentative de phishing."
    >
      <p style={s.intro}>
        Le phishing reste le point d'entrée le plus fréquent des incidents cybersécurité en entreprise, y
        compris pour des attaques ensuite bien plus lourdes comme le ransomware. Reconnaître ses différentes
        formes est la première ligne de défense.
      </p>

      <h2 style={s.h2}>Les principales formes de phishing</h2>
      <ul style={s.ul}>
        <li style={s.li}><strong>Le phishing classique</strong> : un email générique imitant une banque, un fournisseur ou un service connu, envoyé en masse.</li>
        <li style={s.li}><strong>Le spear phishing</strong> : un email ciblé, personnalisé avec des informations réelles sur votre entreprise ou votre interlocuteur, donc plus crédible.</li>
        <li style={s.li}><strong>La fraude au président</strong> : un message se faisant passer pour un dirigeant, demandant en urgence un virement ou des informations confidentielles.</li>
        <li style={s.li}><strong>Le smishing</strong> : la même logique, mais par SMS plutôt que par email.</li>
      </ul>

      <h2 style={s.h2}>Les signaux qui doivent alerter</h2>
      <p>
        Un sentiment d'urgence inhabituel, une demande qui sort du cadre habituel (virement exceptionnel,
        changement de coordonnées bancaires d'un fournisseur), une adresse d'expéditeur légèrement différente
        de l'originale, ou une pièce jointe non attendue sont des signaux classiques. Le meilleur réflexe
        reste de vérifier par un second canal (téléphone, message direct) avant d'agir, plutôt que de répondre
        directement au message suspect.
      </p>

      <h2 style={s.h2}>Prévenir plutôt que guérir</h2>
      <p>
        Une sensibilisation régulière, même courte, réduit fortement le taux de clic sur les emails
        frauduleux. Des simulations de phishing internes permettent de mesurer objectivement la vigilance de
        vos équipes, sans attendre une vraie attaque pour le découvrir. Une procédure claire de vérification
        des virements (double validation, appel de confirmation) neutralise l'essentiel des tentatives de
        fraude au président.
      </p>

      <h2 style={s.h2}>Si un salarié a cliqué ou répondu</h2>
      <p>
        L'erreur arrive, y compris dans des équipes sensibilisées. L'essentiel est qu'elle soit signalée
        immédiatement, sans crainte de sanction, pour permettre une réaction rapide (changement de mot de
        passe, vérification des systèmes concernés) — voir notre article
        {' '}<Link to="/blog/que-faire-apres-cyberattaque" style={s.link}>Que faire après une cyberattaque</Link>{' '}
        pour la marche à suivre complète, et notre article sur le
        {' '}<Link to="/blog/ransomware-entreprise-comprendre-se-proteger" style={s.link}>ransomware</Link>{' '}
        pour comprendre ce que le phishing peut déclencher en aval.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticlePhishing;
